import {Component} from "@mecatran-components/component";



export class Input extends Component{
    constructor(inputOptions){
        super();

        this.initInput(inputOptions);
    }
    // =======
    // private
    // -------
    isInput(element){ return (element.tagName === 'INPUT') }

    setProperty(prop,value){
        var input = this.getDomManager().getDomNode();
        input.setAttribute(prop,value)
    }

    createInputOptions(inputOptions){
        var options = {};
        if (inputOptions){
            options.id = (Input.isString(inputOptions.id)) ? inputOptions.id : '';
            options.src = (Input.isString(inputOptions.src)) ? inputOptions.src : '';
            options.placeholder = (Input.isString(inputOptions.placeholder)) ? inputOptions.placeholder : '';
            options.value = (Input.isString(inputOptions.value) || Input.isNumber(inputOptions.value)) ? inputOptions.value : '';
            options.classList =  (Input.isArray(inputOptions.classList)) ? inputOptions.classList : [];
            options.style = (inputOptions.style) ? inputOptions.style : {};
            options.type = (inputOptions.type) ? inputOptions.type : '';
        }
        return options;
    }
/*
    logInput(event){
        var target = event.target;
        console.log('input value:',target.value)
    }
    */
   onInputInput(event){
        this.emitCustomEvent('inputEvent',{query : event.target.value});
   }

    onInputKeypress(event){
        if (event.keyCode === 13 ) this.onInputEnter(event);
    }

    onInputEnter(event){
        this.emitCustomEvent('enterEvent', {query : event.target.value});
    }

    emitCustomEvent(eventName, detail){  // TMP. Should be located in Component
        var event = new CustomEvent(eventName, { detail, bubbles: true });  // https://developer.mozilla.org/fr/docs/Web/API/Event/Event
        this.getDomManager().getDomNode().dispatchEvent(event);
    } 



    updateInputOptions(options){
        var input = this.getDomManager().getDomNode();
        if (options.id){ input.id = options.id }
        if (options.src){
            input.type = "image";
            input.src = options.src;
            input.setAttribute('width','20px'); // TMP  add in options
        } 
        if (options.type) input.type = options.type;
        if (options.placeholder) input.placeholder = options.placeholder;
        if (options.value) input.value = options.value;
        if (options.classList) options.classList.forEach(className => input.classList.add(className))
        if (options.style){
            var strStyle = Input.serializeObject(options.style); 
            input.setAttribute('style',strStyle)
        }
    }


    initInput(inputOptions){
        this.updateInputOptions(this.createInputOptions(inputOptions));
        this.build();
    }

    // ==========
    // overloaded
    // ----------
    createContainerNode(){
        var input = document.createElement('input');
        return input;
    }

    createContentNode(){ return; }



    defineEventListeners(eventManager){
        eventManager.on('input', this.isInput, this.onInputInput.bind(this), true );
        eventManager.on('keypress',this.isInput, this.onInputKeypress.bind(this),false);
    };

    // ===========
    // API (public)
    // ------------
    getValue(){
        var input = this.getDomManager().getDomNode();
        return input.value;
    }

    setValue(value){  
        this.getDomNode()["value"] = value;
    }

    setPlaceHolder(placeholder){ this.setProperty('placeholder', placeholder);  }

    // https://developer.mozilla.org/fr/docs/Web/HTML/Element/Input#les_diff%C3%A9rents_types_de_champs_%3Cinput%3E
    setTypeButton(){
        this.setProperty('type','button')
    }

    

    // ==========
    // static
    // ----------
    static isString(str){ return (typeof str === 'string')}

    static isNumber(num){ return (typeof num === 'number')}

    static isArray(arr){ return (arr instanceof Array) }

    static serializeObject(object){
        var str = '';
        Object.entries(object).forEach(([k,v])=> str+= `${k}:${v}`)
        return str;
    }


}
/**
 *  input options interface
 * -------------------------  
 * placeholder : string  (optional)
 * value : string  (optional)
 * src : url on an image (optional)
 * type : button 
 * 
 * classList :  array of strings  (optional)
 * style : object  (optional)
 * id : string (optional)
 */
class InputOptions{}

